// extracted by mini-css-extract-plugin
module.exports = {"Balloon":"Footer_Balloon__FCj1z","floating":"Footer_floating__7Ro3v"};